import { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setResult } from './Actions';
import { removeCookie } from './Helper';

class CanIAutoplay extends Component {
  componentDidMount() {
    const { setResult } = this.props;
    setResult();
  }

  componentWillUnmount() {
    removeCookie();
  }

  render() {
    return null;
  }
}

CanIAutoplay.propTypes = {
  setResult: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  const result = _.get(state, 'canIAutoplay.result');
  return { result };
}
const mapDispatchToProps = {
  setResult,
};

export default connect(mapStateToProps, mapDispatchToProps)(CanIAutoplay);
